import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { renderStatusPopupEditor } from '@bingads-webui-campaign/status-popup-editor';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { StatusIconColumn as StatusIconColumnConfig } from '@bingads-webui-campaign/ad-groups-data';
import { InlineEditableSave } from './inline-editable/save';
import statusIconTemplate from './status-icon.pug';
import statusEnumMap from './status-enum-map';
import headerTemplate from './status-icon-header-template.pug';

const pageContext = globalContext.require('PageContext');
const enableGridFlexLayout = _.result(pageContext.Permissions.dynamic, 'GridFlexLayout', false);

export class StatusIconColumn extends CampaignuiBaseColumn {
  constructor({ i18n, view, isForVNext }) {
    super({
      ...StatusIconColumnConfig,
      title: i18n.getString('ColumnName_Status'),
      sortable: 'EntityStatus',
      isResizable: false,
      type: 'string',
      bodyClasses: ['grid-column-Status'],
      enableEdit: item => !_.contains(['Draft', 'Expired'], item.EntityStatus),
      headerTemplate: () => headerTemplate({}),
      group: 'freezing',
    });

    this.i18n = i18n;
    this.view = view;
    this.isForVNext = isForVNext;
  }

  pickProperty(item) {
    const {
      EntityStatus,
      Id,
    } = item;
    const isExperiment = _.result(item.Campaign, 'ExperimentId');

    return {
      EntityStatus,
      Id,
      isExperiment,
    };
  }

  template(model) {
    return statusIconTemplate(_.extend({}, model, {
      i18n: this.i18n,
      isForVNext: this.isForVNext,
      enableGridFlexLayout,
    }));
  }

  onPrompt({ position, item, newPosition }) {
    const statusEditor = renderStatusPopupEditor({
      position: this.isForVNext ? newPosition : position,
      isForVNext: this.isForVNext,
      i18n: this.i18n,
      currentStatus: item.EntityStatus,
      statusOptions: (() => {
        let options = [
          { name: 'Enabled', value: 'Active' },
          { name: 'Paused', value: 'Paused' },
        ];
        const isExperiment = _.result(item.Campaign, 'ExperimentId');

        if (isExperiment) {
          options = _.map(options, (option) => {
            const iconClass = _.result({
              Enabled: 'experiment-active-icon',
              Paused: 'experiment-paused-icon',
            }, option.name);

            return _.defaults({ iconClass }, option);
          });
        }

        return options;
      })(),
    });

    statusEditor.then((status) => {
      if (status) {
        const updated = _.extend({}, item, { Status: status });

        return InlineEditableSave({
          view: this.view,
          i18n: this.i18n,
          fieldName: 'Status',
          updated,
          editorView: statusEditor,
          editorViewCallbackAfterUpdate: () => {
            const response = [{
              Id: item.Id,
              Status: statusEnumMap[status],
            }];

            window.App.trigger('adGroupUpdated', { data: response });
          },
        });
      }
      return undefined;
    });
  }
}
